import { Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { toAbsoluteUrl } from '../../helpers'
import StoreBadge from '../content/StoreBadge'

const APP_STORE_URL = 'https://apps.apple.com/tr/app/netway-hotspot/id6755966982?l=tr'
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.Wisnet.Netway'

function MobileAppModal({ showModal, setShowModal }: any) {
  const intl = useIntl()
  const t = (id: any, values = {}) => intl.formatMessage({ id }, values)

  const handleClose = () => setShowModal(false)

  return (
    <Modal
      style={{ background: 'rgba(0,0,0,0.3)' }}
      show={showModal}
      onHide={handleClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{t('mobile_app_modal_title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body className='text-center py-8'>
        <img
          alt='Netway'
          src={toAbsoluteUrl('/media/logos/Netway-Yatay.png')}
          className='h-80px '
        />
        <p className='fs-5 mt-4 mb-8'>{t('mobile_app_modal_desc')}</p>
        <div className='d-flex justify-content-center align-items-center flex-wrap gap-3'>
          <StoreBadge
            href={APP_STORE_URL}
            img='/media/store/app_store.png'
            alt="App Store'dan indirin"
            height={52}
          />
          <StoreBadge
            href={GOOGLE_PLAY_URL}
            img='/media/store/google_play.png'
            alt="Google Play'den alın"
            height={50}
          />
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default MobileAppModal
